module.exports = __webpack_public_path__ + "5485c223a0d22a86a6c774caa02c2441.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/bird-icon.png
// module id = 817
// module chunks = 0